<div class="sz-skeleton" [class]="'sz-skeleton--' + shape()" [style]="inlineStyle()"></div>
